import React from "react";
import { toast } from "react-toastify";

const ManagePinGroupModal = ({
  groups,
  onPinToggle,
  setSearchQuery,
  filterLoading,
  onModalClose,
}) => {
  const pinnedGroups = groups.filter((group) => group.is_pinned);
  const unpinnedGroups = groups.filter((group) => !group.is_pinned);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div
      className="modal add-task-modal fade"
      id="managePinGroupModal"
      tabIndex="-1"
      aria-labelledby="addNewTaskModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ maxWidth: "150%" }}>
          <div className="modal-header d-flex align-items-center position-relative">
            <h1 className="modal-title text-heading-h2 mb-4 mx-auto">
              Manage Pin Group
            </h1>
            <div className="position-absolute end-0">
              <img
                src="icons/close-btn.svg"
                alt="close"
                style={{ marginTop: "-20px", cursor: "pointer" }}
                data-bs-dismiss="modal"
                onClick={onModalClose}
              />
            </div>
          </div>
          <div className="modal-body">
            <div className="chats-search">
              <input
                className="header-search-1 text-caption-c2"
                type="text"
                placeholder="Search Tribe"
                style={{ width: "100%" }}
                onChange={handleSearch}
              />
            </div>
            {filterLoading ? (
              <div className="flex-grow-1 flex-column chats-contents active-chat">
                <div className="text-center py-5">
                  <div className="loader-container">
                    <div className="loader"></div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* Pinned Groups */}
                <div style={{ color: "#E6ECF1" }}>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      marginBottom: "16px",
                    }}
                  >
                    <span>Pinned Groups</span>
                  </div>

                  {pinnedGroups.map((group) => (
                    <div className="chat-item" key={group.id}>
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="d-flex gap-2 gap-md-3">
                          <img
                            src={group.image || "/icons/chat-liam.svg"}
                            className="profile-img"
                            alt="group"
                          />
                          <div>
                            <div className="d-flex align-items-center">
                              <span className="text-body-b1">{group.name}</span>
                            </div>
                            <p className="text-body-b4 mb-0">
                              Members: {group.member_count}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => onPinToggle(group.id)}
                        >
                          <img src="icons/unpinned-group.svg" alt="" />
                          <span
                            style={{ color: "#008CFF", marginLeft: "10px" }}
                          >
                            Unpin Group
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Unpinned Groups */}
                <div style={{ color: "#E6ECF1" }}>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      marginBottom: "16px",
                    }}
                  >
                    <span>Groups</span>
                  </div>

                  {unpinnedGroups.map((group) => (
                    <div className="chat-item" key={group.id}>
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="d-flex gap-2 gap-md-3">
                          <img
                            src={group.image || "/icons/chat-liam.svg"}
                            className="profile-img"
                            alt="group"
                          />
                          <div>
                            <div className="d-flex align-items-center">
                              <span className="text-body-b1">{group.name}</span>
                            </div>
                            <p className="text-body-b4 mb-0">
                              Members: {group.member_count}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (pinnedGroups.length >= 5) {
                              toast.error("You can only pin up to 5 groups.");
                              return;
                            }
                            onPinToggle(group.id);
                          }}
                        >
                          <img src="icons/pinned-group.svg" alt="" />
                          <span
                            style={{ color: "#008CFF", marginLeft: "10px" }}
                          >
                            Pin Group
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Buttons */}
            <div className="d-flex gap-3 mt-4 justify-content-center">
              <button
                className="btn-1 btn-1-primary px-3 text-body-b1"
                style={{ width: "182px" }}
                data-bs-dismiss="modal"
                onClick={onModalClose}
              >
                Save
              </button>
              <button
                className="btn-1 btn-1-primary px-3 text-body-b1"
                style={{ width: "182px", background: "#eb5757" }}
                data-bs-dismiss="modal"
                onClick={onModalClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagePinGroupModal;
